import React, { Fragment } from 'react';
import styled from '@emotion/styled';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const Wrapper = styled('div')`
  .custom-control-input:disabled ~ .custom-control-label::before {
    border-color: #adb5bd;
  }
  .custom-control-input:disabled:checked ~ .custom-control-label::before {
    background-color: #adb5bd !important;
  }
`;

const Radios = (props) => {
  const { id, name, data, currentValue, disabled = false, onChange, inlineLayout } = props;
  const { t } = useAutoTranslation();

  return (
    <Fragment>
      {data.map((item, i) => (
        <Fragment key={`radio-${i}`}>
          <Wrapper
            className={
              'custom-control custom-radio mt-1 ' + (inlineLayout ? 'custom-control-inline' : '')
            }
            data-testid={`wrapper-radio-${id}-${i}`}
          >
            <input
              type="radio"
              id={`${id}-${i}`}
              data-testid={`radioTestId-${id}-${i}`}
              name={name}
              className="custom-control-input"
              value={item.value}
              checked={item.value === currentValue}
              disabled={disabled}
              onChange={(e) => onChange(e.target.value)}
            />
            <label className="custom-control-label" htmlFor={`${id}-${i}`}>
              {t(item.label)}
            </label>
          </Wrapper>
          {item.description ? <p className="subheader">{item.description}</p> : null}
        </Fragment>
      ))}
    </Fragment>
  );
};

export default Radios;
